// Lógica pura del inicio de sesión del administrador de plataforma (HU-044, CU-022):
// interpretación de las respuestas de POST /v1/platform/auth/login. Sin React, para Vitest.
import {
  PLATFORM_INVALID_CREDENTIALS_MESSAGE,
  PLATFORM_INVALID_TOTP_MESSAGE,
  PLATFORM_LOGIN_RATE_LIMITED_MESSAGE,
  type PlatformAuthErrorBody,
  type PlatformSessionInfo,
} from '@vendedor/shared';

export type LoginOutcome =
  | { kind: 'success'; session: PlatformSessionInfo }
  /** CA-01/CA-04: la cuenta aún no tiene 2FA, hay que configurarlo antes de poder entrar. */
  | { kind: 'totp_setup_required'; adminId: string; otpauthUri: string }
  /** Credenciales correctas, falta el código (el formulario debe pedirlo sin reintentar el POST). */
  | { kind: 'totp_required' }
  | { kind: 'invalid'; message: string }
  | { kind: 'error'; message: string };

const UNEXPECTED = 'No pudimos iniciar tu sesión. Inténtalo de nuevo en unos segundos.';

function isErrorBody(body: unknown): body is PlatformAuthErrorBody {
  return typeof body === 'object' && body !== null && 'code' in body;
}

export function interpretLoginResponse(status: number, body: unknown): LoginOutcome {
  if (status === 200 && typeof body === 'object' && body !== null && 'status' in body) {
    const parsed = body as
      | { status: 'ok'; session: PlatformSessionInfo }
      | { status: 'totp_setup_required'; adminId: string; otpauthUri: string };
    if (parsed.status === 'ok') return { kind: 'success', session: parsed.session };
    return { kind: 'totp_setup_required', adminId: parsed.adminId, otpauthUri: parsed.otpauthUri };
  }
  if (status === 429) return { kind: 'error', message: PLATFORM_LOGIN_RATE_LIMITED_MESSAGE };
  if (isErrorBody(body)) {
    if (body.code === 'totp_required') return { kind: 'totp_required' };
    if (body.code === 'invalid_credentials') {
      return { kind: 'invalid', message: PLATFORM_INVALID_CREDENTIALS_MESSAGE };
    }
    if (body.code === 'invalid_totp') return { kind: 'invalid', message: PLATFORM_INVALID_TOTP_MESSAGE };
    if (body.code === 'validation_failed') return { kind: 'invalid', message: body.message };
  }
  return { kind: 'error', message: UNEXPECTED };
}
